<template>
  <div style="padding:20px;">
    <el-row :gutter="20">
        <template>
          <el-col :span="24">
            <h2 style="margin-top: 0;">渠道部数据统计</h2>
          </el-col>
        </template>
<!--      </el-skeleton>-->
      <el-col :span="24">
        <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
          <el-tab-pane label="渠道-招商加盟" name="merchants">
            <el-row style="margin-bottom: 10px;">
              <el-date-picker class="search-el" size="small" v-model="query.month" value-format='yyyy-MM' type="month" align="right" unlink-panels  :picker-options="pickerOptions">
              </el-date-picker>
              <el-button type="primary" size="mini" @click="getList()">
                查询
              </el-button>
              <el-button type="success" size="mini" @click="dialogVisible = true" style="margin-left: 10px;">
                添加
              </el-button>
            </el-row>
            <el-table :data="listData" style="width: 100%" border  v-loading="listLoading" >
              <el-table-column  label="业务名称" align="center" width="150">
                <el-table-column prop="0" label="订单来源" align="center" width="150"></el-table-column>
              </el-table-column>
              <el-table-column  label="招商-市代、驿站" align="center" width="100">
                <el-table-column prop="1" label="本月销售额" align="center" width="120">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #409eff; text-decoration: underline;" @click="goToOrderList(query.channel_type,type_list[0],'paid',row[13])">{{ row[1] }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="2" label="本月退款额" align="center" width="120">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #f56c6c; text-decoration: underline;" @click="goToOrderList(query.channel_type,type_list[0],'refunds',row[13])">{{ row[2] }}</div>
                  </template>
                </el-table-column>
              </el-table-column>

              <el-table-column  label="招商-研习商学苑" align="center" width="120">
                <el-table-column prop="3" label="本月销售额" align="center" width="120">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #409eff; text-decoration: underline;" @click="goToOrderList(query.channel_type,type_list[1],'paid',row[13])">{{ row[3] }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="4" label="本月退款额" align="center" width="120">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #f56c6c; text-decoration: underline;" @click="goToOrderList(query.channel_type,type_list[1],'refunds',row[13])">{{ row[4] }}</div>
                  </template>
                </el-table-column>
              </el-table-column>

              <el-table-column  label="招商-发光者计划" align="center" width="120">
                <el-table-column prop="5" label="本月销售额" align="center" width="120">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #409eff; text-decoration: underline;" @click="goToOrderList(query.channel_type,type_list[2],'paid',row[13])">{{ row[5] }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="6" label="本月退款额" align="center" width="120">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #f56c6c; text-decoration: underline;" @click="goToOrderList(query.channel_type,type_list[2],'refunds',row[13])">{{ row[6] }}</div>
                  </template>
                </el-table-column>
              </el-table-column>

              <el-table-column  label="招商-遇见门票" align="center" width="120">
                <el-table-column prop="7" label="本月销售额" align="center" width="120">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #409eff; text-decoration: underline;" @click="goToOrderList(query.channel_type,type_list[3],'paid',row[13])">{{ row[7] }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="8" label="本月退款额" align="center" width="120">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #f56c6c; text-decoration: underline;" @click="goToOrderList(query.channel_type,type_list[3],'refunds',row[13])">{{ row[8] }}</div>
                  </template>
                </el-table-column>
              </el-table-column>

              <el-table-column  label="招商-线下课程" align="center" width="120">
                <el-table-column prop="9" label="本月销售额" align="center" width="120">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #409eff; text-decoration: underline;" @click="goToOrderList(query.channel_type,type_list[4],'paid',row[13])">{{ row[9] }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="10" label="本月退款额" align="center" width="120">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #f56c6c; text-decoration: underline;" @click="goToOrderList(query.channel_type,type_list[4],'refunds',row[13])">{{ row[10] }}</div>
                  </template>
                </el-table-column>
              </el-table-column>

              <el-table-column label="合计" align="center" width="150">
                <el-table-column prop="11" label="本月销售额合计" align="center" width="160">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #409eff; text-decoration: underline" @click="goToOrderList(query.channel_type,'total','paid',row[13])">{{ row[11] }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="12" label="本月退款额合计" align="center" width="160">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #f56c6c; text-decoration: underline" @click="goToOrderList(query.channel_type,'total','refunds',row[13])">{{ row[12] }}</div>
                  </template>
                </el-table-column>
              </el-table-column>


<!--              <el-table-column label="合计" width="150">
                <template slot-scope="{row}">
                  <p>本月销售额{{row[9]}}</p>
                  <p>本月退款额{{row[10]}}</p>
                </template>
              </el-table-column>-->
            </el-table>
          </el-tab-pane>

          <!--渠道运营-->
          <el-tab-pane label="渠道运营" name="operationData">
            <el-row style="margin-bottom: 10px;">
              <el-date-picker class="search-el" size="small" v-model="query.month" value-format='yyyy-MM' type="month" align="right" unlink-panels  :picker-options="pickerOptions">
              </el-date-picker>
              <el-button type="primary" size="mini" @click="getOperationDataList()">
                查询
              </el-button>
            </el-row>
            <el-table :data="operationDataList" style="width: 100%" border  v-loading="operationDataListLoading" >
              <el-table-column  label="业务名称" align="center" width="150">
                <el-table-column prop="0" label="订单来源" align="center" width="150"></el-table-column>
              </el-table-column>

              <el-table-column  label="体验营" align="center" width="180">
                <el-table-column prop="1" label="本月销售额" align="center" width="120">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #409eff; text-decoration: underline;" @click="goToOrderList(query.channel_type,type_list[0],'paid',row[13])">{{ row[1] }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="2" label="本月订单数" align="center" width="120">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #409eff; text-decoration: underline;" @click="goToOrderList(query.channel_type,type_list[0],'paid',row[13])">{{ row[2] }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="3" label="本月退款额" align="center" width="120">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #f56c6c; text-decoration: underline;" @click="goToOrderList(query.channel_type,type_list[0],'refunds',row[13])">{{ row[3] }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="4" label="本月退款订单数" align="center" width="120">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #f56c6c; text-decoration: underline;" @click="goToOrderList(query.channel_type,type_list[0],'refunds',row[13])">{{ row[4] }}</div>
                  </template>
                </el-table-column>
              </el-table-column>

              <el-table-column  label="发光者" align="center" width="180">
                <el-table-column prop="5" label="本月销售额" align="center" width="120">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #409eff; text-decoration: underline;" @click="goToOrderList(query.channel_type,type_list[1],'paid',row[13])">{{ row[5] }}</div>
                  </template>
                </el-table-column>

                <el-table-column prop="6" label="本月订单数" align="center" width="120">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #409eff; text-decoration: underline;" @click="goToOrderList(query.channel_type,type_list[1],'paid',row[13])">{{ row[6] }}</div>
                  </template>
                </el-table-column>

                <el-table-column prop="7" label="本月退款额" align="center" width="120">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #f56c6c; text-decoration: underline;" @click="goToOrderList(query.channel_type,type_list[1],'refunds',row[13])">{{ row[7] }}</div>
                  </template>
                </el-table-column>

                <el-table-column prop="8" label="本月退款订单数" align="center" width="120">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #f56c6c; text-decoration: underline;" @click="goToOrderList(query.channel_type,type_list[1],'refunds',row[13])">{{ row[8] }}</div>
                  </template>
                </el-table-column>

              </el-table-column>


              <el-table-column label="合计" align="center" width="150">
                <el-table-column prop="9" label="本月销售额合计" align="center" width="160">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #409eff; text-decoration: underline;" @click="goToOrderList(query.channel_type,'total','paid',row[13])">{{ row[9] }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="9" label="本月订单数合计" align="center" width="160">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #409eff; text-decoration: underline;" @click="goToOrderList(query.channel_type,'total','paid',row[13])">{{ row[10] }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="10" label="本月退款额合计" align="center" width="160">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #f56c6c; text-decoration: underline;" @click="goToOrderList(query.channel_type,'total','refunds',row[13])">{{ row[11] }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="10" label="本月退款订单数合计" align="center" width="160">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #f56c6c; text-decoration: underline;" @click="goToOrderList(query.channel_type,'total','refunds',row[13])">{{ row[12] }}</div>
                  </template>
                </el-table-column>
<!--                <template slot-scope="{row}">
                  <p>本月销售额{{row[9]}}</p>
                  <p>本月退款额{{row[10]}}</p>
                </template>-->
              </el-table-column>
            </el-table>
          </el-tab-pane>

          <!--渠道沙龙-->
          <el-tab-pane label="渠道沙龙" name="salonData">
            <el-row style="margin-bottom: 10px;">
              <el-date-picker class="search-el" size="small" v-model="query.month" value-format='yyyy-MM' type="month" align="right" unlink-panels  :picker-options="pickerOptions">
              </el-date-picker>
              <el-button type="primary" size="mini" @click="getSalonDataList()">
                查询
              </el-button>
              <el-button type="success" size="mini" @click="dialogVisible = true" style="margin-left: 10px;">
                添加
              </el-button>
            </el-row>
            <el-table :data="salonDataList" style="width: 100%" border  v-loading="salonDataListLoading" >
              <el-table-column  label="业务名称" align="center" width="150">
                <el-table-column prop="0" label="订单来源" align="center" width="150"></el-table-column>
              </el-table-column>

              <el-table-column  label="沙龙-幸福心理商学苑" align="center" width="225">
                <el-table-column prop="1" label="本月销售额" align="center" width="120">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #409eff;" @click="goToOrderList(query.channel_type,type_list[0],'paid',row[17])">{{ row[1] }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="2" label="本月订单数" align="center" width="120">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #409eff;" @click="goToOrderList(query.channel_type,type_list[0],'paid',row[17])">{{ row[2] }}</div>
                  </template>
                </el-table-column>

                <el-table-column prop="3" label="本月退款额" align="center" width="120">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #f56c6c;" @click="goToOrderList(query.channel_type,type_list[0],'refunds',row[17])">{{ row[3] }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="4" label="本月退款订单数" align="center" width="120">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #f56c6c;" @click="goToOrderList(query.channel_type,type_list[0],'refunds',row[17])">{{ row[4] }}</div>
                  </template>
                </el-table-column>
              </el-table-column>

              <el-table-column  label="沙龙-线上课程" align="center" width="210">
                <el-table-column prop="5" label="本月销售额" align="center" width="120">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #409eff;" @click="goToOrderList(query.channel_type,type_list[1],'paid',row[17])">{{ row[5] }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="6" label="本月订单数" align="center" width="120">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #409eff;" @click="goToOrderList(query.channel_type,type_list[1],'paid',row[17])">{{ row[6] }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="7" label="本月退款额" align="center" width="120">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #f56c6c;" @click="goToOrderList(query.channel_type,type_list[1],'refunds',row[17])">{{ row[7] }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="8" label="本月退款订单数" align="center" width="120">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #f56c6c;" @click="goToOrderList(query.channel_type,type_list[1],'refunds',row[17])">{{ row[8] }}</div>
                  </template>
                </el-table-column>
              </el-table-column>

              <el-table-column  label="沙龙-线下课程" align="center" width="210">
                <el-table-column prop="9" label="本月销售额" align="center" width="120">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #409eff;" @click="goToOrderList(query.channel_type,type_list[2],'paid',row[17])">{{ row[9] }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="10" label="本月订单数" align="center" width="120">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #409eff;" @click="goToOrderList(query.channel_type,type_list[2],'paid',row[17])">{{ row[10] }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="11" label="本月退款额" align="center" width="120">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #f56c6c;" @click="goToOrderList(query.channel_type,type_list[2],'refunds',row[17])">{{ row[11] }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="12" label="本月退款订单数" align="center" width="120">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #f56c6c;" @click="goToOrderList(query.channel_type,type_list[2],'refunds',row[17])">{{ row[12] }}</div>
                  </template>
                </el-table-column>
              </el-table-column>

              <el-table-column label="合计" align="center" width="150">
                <el-table-column prop="13" label="本月销售额合计" align="center" width="120">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #409eff;" @click="goToOrderList(query.channel_type,'total','paid',row[17])">{{ row[13] }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="14" label="本月订单数合计" align="center" width="120">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #409eff;" @click="goToOrderList(query.channel_type,'total','paid',row[17])">{{ row[14] }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="15" label="本月退款额合计" align="center" width="120">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #f56c6c;" @click="goToOrderList(query.channel_type,'total','refunds',row[17])">{{ row[15] }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="16" label="本月退款订单数合计" align="center" width="120">
                  <template slot-scope="{row}">
                    <div style="cursor: pointer; color: #f56c6c;" @click="goToOrderList(query.channel_type,'total','refunds',row[17])">{{ row[16] }}</div>
                  </template>
                </el-table-column>
<!--                <template slot-scope="{row}">
                  <p>本月销售额{{row[11]}}</p>
                  <p>本月退款额{{row[12]}}</p>
                </template>-->
              </el-table-column>
            </el-table>
          </el-tab-pane>


        </el-tabs>
      </el-col>
    </el-row>

    <!-- 添加订单弹窗 -->
    <el-dialog title="添加订单" :visible.sync="dialogVisible" width="30%">
      <el-form label-width="80px">
        <el-form-item label="订单号" required>
          <el-input v-model="orderForm.order_no" placeholder="请输入订单号" clearable @input="orderForm.order_no = orderForm.order_no.replace(/[^a-zA-Z0-9_]/g, '')"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="submitLoading" @click="submitOrder">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getList,
  getOperationList,
  addPerformanceStatisticsOrder,
  getSalonList
} from "@/api/channel";
/*import { setTimeout } from 'timers';*/

export default {
  data: function() {
    return {
      query:{
        month:new Date().getFullYear() + '-' + String(new Date().getMonth() + 1).padStart(2, '0'),
        channel_type:1,
        type:1,
        transaction_type:'paid',
        payment_method:'',
        source:'',
      },
      activeName: 'merchants',
      listData:[],
      listLoading:true,
      operationDataList:[],
      operationDataListLoading:true,
      salonDataList:[],
      salonDataListLoading:true,
      dialogVisible: false,
      submitLoading: false,
      orderForm: {
        order_no: '',
        type:1,
      },
      channel_type_list:[1,2,3],//1招商，2运营，3沙龙
      type_list:[1,2,3,4,5,6],
      pickerOptions: {
        /*shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]*/
      },
    };
  },
  created: function() {
    let channel = localStorage.getItem('channel_type');
    switch (channel) {
      case '1':
        this.activeName = 'merchants';
        this.orderForm.type = 1
        this.getList();
        break;
      case '2':
        this.activeName = 'operationData';
        this.getOperationDataList();
        this.orderForm.type = 2
        break;
      case '3':
        this.activeName = 'salonData';
        this.getSalonDataList();
        this.orderForm.type = 3
        break;
      default:
        this.activeName = 'merchants';
        this.getList();
        this.orderForm.type = 1
        break;
    }
    localStorage.setItem('channel_type', '')
    //this.getList();
  },
  methods: {
    getList(){
      /*if(localStorage.getItem('month')){
        this.query.month = localStorage.getItem('month')
        localStorage.setItem('month', '')
      }

      if(localStorage.getItem('channel_type')){
        this.query.channel_type = localStorage.getItem('channel_type')
        localStorage.setItem('channel_type', '')
      }*/
      if(localStorage.getItem('month')){
        this.query.month = localStorage.getItem('month')
        localStorage.setItem('month', '')
      }
      this.listLoading = true;
      this.query.channel_type = 1
      console.log(this.query)
      getList(this.query).then(response => {
        this.listData = response.data.list
        this.listLoading = false;
      });
    },

    getOperationDataList(){
      if(localStorage.getItem('month')){
        this.query.month = localStorage.getItem('month')
        localStorage.setItem('month', '')
      }
      this.operationDataListLoading = true;
      this.query.channel_type = 2
      getOperationList(this.query).then(response => {
        this.operationDataList = response.data.list
        this.operationDataListLoading = false;
      });
    },
    getSalonDataList(){
      if(localStorage.getItem('month')){
        this.query.month = localStorage.getItem('month')
        localStorage.setItem('month', '')
      }
      this.salonDataListLoading = true;
      this.query.channel_type = 3
      getSalonList(this.query).then(response => {
        this.salonDataList = response.data.list
        this.salonDataListLoading = false;
      });
    },
    /*updateChakras(id){
      this.$router.push({
        path: "/activity/chakras/info",
        query: {type:'update', id:id}
      });
    },*/

    handleClick(tab) {
      switch (tab.name) {
        case 'merchants':
          this.getList();
          this.orderForm.type = 1
          break;
        case 'operationData':
          this.getOperationDataList();
          this.orderForm.type = 2
          break;
        case 'salonData':
          this.getSalonDataList();
          this.orderForm.type = 3
          break;
      }
    },
    goToOrderList(channel_type,type,transaction_type,pay_source){
      if(pay_source == 'total'){
        this.query.source = pay_source
      }else{
        let a = new Array('xiaoetong','wxvideo');
        if(a.indexOf(pay_source) !== -1){//是小鹅通或者视频号
          this.query.source = pay_source
        }else{
          this.query.payment_method = pay_source
        }
      }
      this.query.channel_type = channel_type;
      this.query.type = type;
      this.query.transaction_type = transaction_type;
      this.$router.push({
        path: "/statistics/channelOrderList",
        query: this.query
      });
    },
    submitOrder() {
      if (!this.orderForm.order_no) {
        this.$message.warning('请输入订单号');
        return;
      }
      const reg = /^[a-zA-Z0-9_]+$/;
      if (!reg.test(this.orderForm.order_no)) {
        this.$message.warning('订单号仅支持输入数字、字母和下划线');
        return;
      }
      this.submitLoading = true;
      addPerformanceStatisticsOrder(this.orderForm).then(response => {
        if (response.status !== '2000') {
          this.$message.error(response.data);
          this.submitLoading = false;
          return;
        }
        this.$message.success(response.data);
        this.dialogVisible = false;
        this.submitLoading = false;
        this.orderForm.order_no = '';
        this.getSalonDataList(); // 添加成功后重新获取列表
        this.getList();
      });
    }
  }
};
</script>

